import dynamic from "next/dynamic";
import type { ThemeSlots } from "../../types";

/**
 * B2B slot overrides.
 *
 * ClientEditor: the redesigned client editor (one page, one save, inheritance shown per
 * setting). Loaded lazily on purpose — the editor's Look section reads the theme registry,
 * and the registry imports this theme, so a static import would be a module cycle.
 *
 * B2B's structural overrides still live in src/app/globals.css under
 * `html[data-theme="b2b"] { ... }` until they are migrated into real component overrides.
 */
export const slots: ThemeSlots = {
  ClientEditor: dynamic(() => import("@/app/clients/edit/[clientId]/ModernClientEditor"), { ssr: false }),
};
